import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "opModal p-3" }
const _hoisted_2 = { class: "form-group" }
const _hoisted_3 = { class: "control-label" }
const _hoisted_4 = ["onUpdate:modelValue"]
const _hoisted_5 = { class: "form-group" }
const _hoisted_6 = { class: "control-label" }
const _hoisted_7 = ["onUpdate:modelValue"]
const _hoisted_8 = { class: "form-group text-center" }
const _hoisted_9 = ["href"]
const _hoisted_10 = ["src"]
const _hoisted_11 = ["onClick"]
const _hoisted_12 = {
  key: 2,
  class: "text-center"
}
const _hoisted_13 = ["onClick", "disabled"]
const _hoisted_14 = { class: "form-group text-center" }
const _hoisted_15 = ["onUpdate:modelValue"]
const _hoisted_16 = { class: "form-group" }
const _hoisted_17 = { class: "control-label" }
const _hoisted_18 = { class: "d-flex justify-content-between" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_localized_text = _resolveComponent("localized-text")!
  const _component_localized_value = _resolveComponent("localized-value")!
  const _component_file_dropper = _resolveComponent("file-dropper")!
  const _component_tiny_editor = _resolveComponent("tiny-editor")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("label", _hoisted_3, [
        _createVNode(_component_localized_text, {
          localizedKey: "Titolo",
          text: "Titolo"
        })
      ]),
      _createVNode(_component_localized_value, null, {
        default: _withCtx((slotData) => [
          _withDirectives(_createElementVNode("input", {
            class: "form-control",
            type: "text",
            "onUpdate:modelValue": ($event: any) => ((_ctx.content.title.values[slotData.selectedLanguage]) = $event)
          }, null, 8, _hoisted_4), [
            [_vModelText, _ctx.content.title.values[slotData.selectedLanguage]]
          ])
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("label", _hoisted_6, [
        _createVNode(_component_localized_text, {
          localizedKey: "Sottotitolo",
          text: "Sottotitolo"
        })
      ]),
      _createVNode(_component_localized_value, null, {
        default: _withCtx((slotData) => [
          _withDirectives(_createElementVNode("input", {
            class: "form-control",
            type: "text",
            "onUpdate:modelValue": ($event: any) => ((_ctx.content.subTitle.values[slotData.selectedLanguage]) = $event)
          }, null, 8, _hoisted_7), [
            [_vModelText, _ctx.content.subTitle.values[slotData.selectedLanguage]]
          ])
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("label", null, [
        _createVNode(_component_localized_text, {
          localizedKey: "Video (viene caricato su S3)",
          text: "Video (viene caricato su S3)"
        })
      ]),
      _createVNode(_component_localized_value, null, {
        default: _withCtx((slotData) => [
          (!_ctx.preview.values[slotData.selectedLanguage])
            ? (_openBlock(), _createBlock(_component_file_dropper, {
                key: 0,
                modelValue: _ctx.fileToUpload,
                "onUpdate:modelValue": [
                  _cache[0] || (_cache[0] = ($event: any) => ((_ctx.fileToUpload) = $event)),
                  ($event: any) => (_ctx.onFileToUploadChange($event, slotData.selectedLanguage))
                ]
              }, null, 8, ["modelValue", "onUpdate:modelValue"]))
            : (_openBlock(), _createElementBlock("a", {
                key: 1,
                href: _ctx.content.url.values[slotData.selectedLanguage],
                target: "_blank",
                class: "preview"
              }, [
                _createElementVNode("img", {
                  src: _ctx.preview.values[slotData.selectedLanguage]
                }, null, 8, _hoisted_10),
                _createElementVNode("button", {
                  type: "button",
                  onClick: _withModifiers(($event: any) => (_ctx.preview.values[slotData.selectedLanguage] = null), ["stop","prevent"])
                }, [
                  _createVNode(_component_localized_text, {
                    localizedKey: "Modifica",
                    text: "Modifica"
                  })
                ], 8, _hoisted_11)
              ], 8, _hoisted_9)),
          (_ctx.fileToUpload)
            ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                _createElementVNode("button", {
                  type: "button",
                  onClick: ($event: any) => (_ctx.uploadVideo(slotData.selectedLanguage)),
                  disabled: _ctx.loadingVideo
                }, [
                  (!_ctx.loadingVideo)
                    ? (_openBlock(), _createBlock(_component_localized_text, {
                        key: 0,
                        localizedKey: "Carica su server",
                        text: "Carica su server"
                      }))
                    : (_openBlock(), _createBlock(_component_localized_text, {
                        key: 1,
                        localizedKey: "Attendi per favore",
                        text: "Attendi per favore"
                      }))
                ], 8, _hoisted_13)
              ]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ]),
    _createVNode(_component_localized_value, null, {
      default: _withCtx((slotData) => [
        _createElementVNode("div", _hoisted_14, [
          _createElementVNode("label", null, [
            _createVNode(_component_localized_text, {
              localizedKey: "Url del video",
              text: "Url del video"
            })
          ]),
          _withDirectives(_createElementVNode("input", {
            class: "form-control",
            type: "text",
            "onUpdate:modelValue": ($event: any) => ((_ctx.content.url.values[slotData.selectedLanguage]) = $event)
          }, null, 8, _hoisted_15), [
            [_vModelText, _ctx.content.url.values[slotData.selectedLanguage]]
          ])
        ])
      ]),
      _: 1
    }),
    _createVNode(_component_localized_value, null, {
      default: _withCtx((slotData) => [
        _createElementVNode("div", _hoisted_16, [
          _createElementVNode("label", _hoisted_17, [
            _createVNode(_component_localized_text, {
              localizedKey: "Parte testuale",
              text: "Parte testuale"
            })
          ]),
          _createVNode(_component_tiny_editor, {
            modelValue: _ctx.content.textContent.values[slotData.selectedLanguage],
            "onUpdate:modelValue": ($event: any) => ((_ctx.content.textContent.values[slotData.selectedLanguage]) = $event)
          }, null, 8, ["modelValue", "onUpdate:modelValue"])
        ])
      ]),
      _: 1
    }),
    _cache[3] || (_cache[3] = _createElementVNode("hr", null, null, -1)),
    _createElementVNode("div", _hoisted_18, [
      _createElementVNode("button", {
        type: "button",
        class: "btn btn-danger",
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.annulla && _ctx.annulla(...args)))
      }, [
        _createVNode(_component_localized_text, {
          localizedKey: "Annulla modifiche e chiudi",
          text: "Annulla modifiche e chiudi"
        })
      ]),
      _createElementVNode("button", {
        type: "button",
        class: "btn btn-success",
        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('close')))
      }, [
        _createVNode(_component_localized_text, {
          localizedKey: "Ok e chiudi",
          text: "Ok e chiudi"
        })
      ])
    ])
  ]))
}